import { type AxiosInstance } from "axios";

import type {
  ApiShowResponse,
  Order,
  OrderGetRequestParameters,
  OrderLawyerPutRequestBody,
  OrderPutRequestBody,
  OrdersGetRequestParameters,
  OrdersIndexResponse,
  OrdersPostRequestBody,
} from "@ndpco/types";

export const getOrders = async (
  axiosInstance: AxiosInstance,
  params?: OrdersGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<OrdersIndexResponse>>(`/api/v1/service/orders`, {
    params: params,
  });
};

export const getOrderById = async (
  axiosInstance: AxiosInstance,
  id: number,
  params?: OrderGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<Order>>(`/api/v1/service/orders/${id}`, {
    params: params,
  });
};

export const getOrderByFastAccessSlug = async (
  axiosInstance: AxiosInstance,
  fastAccessSlug: string,
  params?: OrderGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<Order>>(
    `/api/v1/service/orders/by-fa/${fastAccessSlug}`,
    {
      params: params,
    }
  );
};

export const getOrderByFastFeedbackSlug = async (
  axiosInstance: AxiosInstance,
  fastFeedbackSlug: string,
  params?: OrderGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<Order>>(
    `/api/v1/service/orders/by-ff/${fastFeedbackSlug}`,
    {
      params: params,
    }
  );
};

export const createOrder = async (axiosInstance: AxiosInstance, data: OrdersPostRequestBody) => {
  return await axiosInstance.post("/api/v1/service/orders", data);
};

export const createSecureCall = async (axiosInstance: AxiosInstance, id: number) => {
  return await axiosInstance.post(`/api/v1/service/orders/${id}/secure-call`);
};

export const updateOrder = async (
  axiosInstance: AxiosInstance,
  id: number,
  data: OrderPutRequestBody
) => {
  return await axiosInstance.patch<ApiShowResponse<Order>>(`/api/v1/service/orders/${id}`, data);
};

export const updateOrderLawyer = async (
  axiosInstance: AxiosInstance,
  id: number,
  data: OrderLawyerPutRequestBody
) => {
  return await axiosInstance.patch<ApiShowResponse<Order>>(
    `/api/v1/service/orders/${id}/lawyer`,
    data
  );
};

export const deleteOrder = async (axiosInstance: AxiosInstance, id: number) => {
  return await axiosInstance.delete(`/api/v1/service/orders/${id}`);
};
